import store from "../../store";
import axiosApi from "../../plugin/axiosApi"
import imageCompression from 'browser-image-compression'
/**
 * Routine to check and resolve all pending messages across all conversations
 * This function should be called periodically or triggered when connection is restored
 */
let executionChain = Promise.resolve();

function resolvePendingMessagesSequential() {
  executionChain = executionChain.then(async () => {
    try {
      await resolvePendingMessages();
    } catch (err) {
      console.error("Routine failed:", err);
    }
  });

  return executionChain;
}

async function resolvePendingMessages() {
  const messages = store.state.messages;
  
  if (!messages) {
    console.log('No messages in store');
    return;
  }
  
  console.log('Starting pending messages resolution routine...');
  
  let totalPending = 0;
  let totalResolved = 0;
  let totalFailed = 0;
  
  // Iterate through all conversations
  for (const userId in messages) {
    const conversation = store.state.messages[userId];
    
    if (!Array.isArray(conversation)) continue;
    
    // Find all pending messages (isLoading === true)
    const pendingMessages = conversation.filter(msg => msg.isLoading === true);
    
    if (pendingMessages.length === 0) continue;
    
    console.log(`Found ${pendingMessages.length} pending messages in conversation with user ${userId}`);
    totalPending += pendingMessages.length;
    
    // Resolve each pending message one by one
    for (const message of pendingMessages) {
      try {
        // Determine which function to call based on message state
        
        // CASE 1: Message has deletedAt (delete operation)
        if (message.deletedAt !== null && message.deletedAt !== undefined) {
          console.log(`Resolving pending DELETE for message ${message._id}`);
          await deleteMessage(message, userId);
          totalResolved++;
        }
        // CASE 2: Message ID contains 'pending_' (create operation)
        else if (message._id && message._id.toString().includes('pending_')) {
          console.log(`Resolving pending CREATE for message ${message._id}`);
          await createMessage(message, userId);
          totalResolved++;
        }
        // CASE 3: All other pending messages (modify operation)
        else {
          console.log(`Resolving pending MODIFY for message ${message._id}`);
          await modifyMessage(message, userId);
          totalResolved++;
        }
        
      } catch (error) {
        console.error(`Failed to resolve pending message ${message._id}:`, error);
        totalFailed++;
        
        // Optionally: You can decide to continue or stop on error
        // For now, we continue to try resolving other messages
      }
    }
  }
  
  console.log(`Pending messages resolution complete:
    Total pending: ${totalPending}
    Successfully resolved: ${totalResolved}
    Failed: ${totalFailed}
  `);
  
  return {
    totalPending,
    totalResolved,
    totalFailed
  };
}
/**
 * Placeholder functions - You'll implement these
 */
async function deleteMessage(message, userId) {

  const res = await axiosApi.post('/chat.php',{type:"deleteMessage",messageId:message._id})
  console.log(res)
  // deletion sucessfull
  store.commit('updateMessage', {
    userId: userId,
    messageId: message._id,
    updates: {
      deletedAt: new Date(),
      isLoading:false
    }
  });
}

async function createMessage(message, userId) {

  const image = await urlToFile(message.img)
  const audio = await urlToFile(message.audio)

  let compressedCoverFile = image
  if(image && !(image.type === "image/svg+xml")) { // if it is not an svg
      const compressedCover = await imageCompression(image, {
        maxSizeMB: 1,
        maxWidthOrHeight: 800,
        useWebWorker: true,
        fileType: 'image/jpeg',
        initialQuality: 0.82
      })
      compressedCoverFile = new File(
        [compressedCover],
        image.name.replace(/\.[^.]+$/, '') + '.jpg',
        { type: 'image/jpeg' }
      )
    }



  const form = new FormData();
  form.append("type", "sendMessage");
  form.append("userId", userId);
  form.append("message", message.text ?? '');
  form.append("image", compressedCoverFile);
  form.append("audio", audio);
  form.append("replyingMessageId", message.replyingMessageId ?? '');
  
  const res = await axiosApi.post('/chat.php',form,{ headers: { "Content-Type": "multipart/form-data", },})
  
  // delete pending message
  store.commit('deleteMessage', {
    userId: userId,
    messageId: message._id
  });
  // Add real message to store
  store.commit('addMessagesToConversation', {
    userId: userId,
    messages: [res.data]
  });

}

async function modifyMessage(message, userId) {

  await axiosApi.post('/chat.php',{type:"modifyMessage",messageId:message._id,
  message:message.text})

  store.commit('updateMessage', {
      userId: userId,
      messageId: message._id,
      updates: {
      text: message.text,
      modifiedAt: new Date(),
      isLoading:false
      }
  });
}

async function urlToFile(url, filename) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    // Try to extract file type
    const contentType = blob.type || "application/octet-stream";

    // If no filename provided, infer from URL
    const name =
        filename ||
        url.split("/").pop()?.split("?")[0] ||
        `file.${contentType.split("/")[1] || "bin"}`;

    return new File([blob], name, { type: contentType });
  }
  catch (err) { return null }
}


export { deleteMessage, createMessage, modifyMessage, resolvePendingMessagesSequential }